import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";

const ThemeToggle = () => {
	const { isDark, toggleTheme } = useTheme();

	return (
		<button
			onClick={toggleTheme}
			className="relative p-2 rounded-full bg-gray-200 dark:bg-gray-700 transition-colors duration-200 sm:ml-0 ml-auto"
			aria-label="Toggle theme"
		>
			<div className="w-16 h-8 relative">
				<div
					className={`
            absolute w-8 h-8 rounded-full transition-transform duration-200 transform
            ${
							isDark
								? "translate-x-9 bg-gray-800"
								: "translate-x-0 bg-yellow-400"
						}
          `}
				/>
				<div className="absolute inset-0 flex justify-between items-center px-0">
					<Sun className={"text-yellow-400"} />
					<Moon className={`${isDark ? "text-gray-100" : "text-gray-700"}`} />
				</div>
			</div>
		</button>
	);
};

export default ThemeToggle;
